export const pendingContractToolbarConfig = [
    {
        id: "createAgreement",
        titleText: "Create Agreement",
        textWithIcon: true,
        isIcon: true,
        iconClass: "bx:bx-receipt",
        buttonTypeClassName: "default-btn border-right",
        actionName: "Create Agreement",
    },
    {
        id: "createContract",
        titleText: "Create Contract",
        textWithIcon: true,
        isIcon: true,
        iconClass: "bx:bxs-file-plus",
        buttonTypeClassName: "default-btn border-right",
        actionName: "Create Contract",
    },
    {
        id: "saveContract",
        titleText: "Save Contract",
        textWithIcon: true,
        isIcon: true,
        iconClass: "ion:save-outline",
        buttonTypeClassName: "default-btn border-right",
        actionName: "SAVE",
    },
    {
        id: "closeContract",
        titleText: "Close Contract",
        textWithIcon: true,
        isIcon: true,
        iconClass: "bx:window-close",
        buttonTypeClassName: "default-btn border-right",
        actionName: "CLOSE",
    },
    {
        id: "delete",
        titleText: "Delete",
        textWithIcon: true,
        isIcon: true,
        iconClass: "bx:bx-trash-alt",
        buttonTypeClassName: "default-btn",
        actionName: "DELETE",
    },
]

